<template>
<!--  :confirmDisabled="updateFields.length < 2" -->
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      :footer="false">
    <template #header>
      <span>导入更新产品</span>
    </template>
    <template #content>
<!--      <p>{{updateFields | json}}</p>-->
      <div class="gj-import-title gj-mb10">请选择需要更新的内容</div>
      <gj-checkbox-group
          v-for="(fieldGroup, i) in fieldGroups"
          v-model="tplFields[i]"
          :key="i"
          :all-checkbox="{label: fieldGroup.label, class: 'all-checkbox'}"
          class="checkbox-group">
        <el-row>
          <el-col
              v-for="item in fieldGroup.fields"
              :key="item.value"
              :span="4"
              class="checkbox">
            <gj-checkbox
                :label="item"
                :disabled="item.disabled">
              {{item.label}}
            </gj-checkbox>
          </el-col>
        </el-row>
      </gj-checkbox-group>
      <gj-upload
          class="upload-btn"
          download-template
          container-type="product"
          template-url="/supply/product/downloadImportUpdateTemp"
          :template-params="updateFieldParams"
          :download-template-disabled="updateFields.length < 2"
          @uploadAfter="uploadAfter"
          style="margin-bottom: 12px;"
      >
      </gj-upload>
      <gj-import-alert
          :rules="[
            {text: '只针对勾选字段更新，请务必按照模板字段填写更新内容', style: {color: 'red'}},
            {text: '模板字段若为非必填字段，且单元格不填值，系统将更新为空值', style: {color: 'red'}},
            '支持导入格式为xls/xlsx的文件',
            '同一个SKU存在多条记录，以第一条记录为准',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "../../../../../minxins";
  import {importUpdateProduct} from "../../../../../api/product";

  export default {
    name: "app-import-update-product-modal",
    mixins: [modalMixIn, uploadMixin],
    created() {
      this.tplFields[0][0] = this.fieldGroups[0].fields[0];
    },
    data() {
      return {
        tplFields: [[], [], [], []],
        fieldGroups: [
          {
            label: '基础信息',
            fields: [
              {label: 'SKU', value: 'sku', disabled: true},
              {label: '产品名称', value: 'name'},
              {label: '图片链接', value: 'smallImageUrl'},
              {label: '产品状态', value: 'state'},
              {label: '品类', value: 'categoryName'},
              {label: '品牌', value: 'brandName'},
              {label: '单位', value: 'unit'},
              {label: '产品开发', value: 'productDeveloper'},
              {label: '产品描述', value: 'description'},
            ]
          },
          {
            label: '采购信息',
            fields: [
              // {label: '采购状态', value: '10'},
              {label: '采购员', value: 'buyer'},
              {label: '预计交期', value: 'expectDeliveryDays'},
              {label: '产品材质', value: 'material'},
              {label: '单品尺寸(长)', aliasName: '单品尺寸长', value: 'singleProductSizeL'},
              {label: '单品尺寸(宽)', aliasName: '单品尺寸宽)', value: 'singleProductSizeW'},
              {label: '单品尺寸(高)', aliasName: '单品尺寸高', value: 'singleProductSizeH'},
              {label: '单品净重', value: 'singleProductNetWeight'},
              {label: '包装尺寸(长)', aliasName: '包装尺寸长', value: 'packageL'},
              {label: '包装尺寸(宽)', aliasName: '包装尺寸宽', value: 'packageW'},
              {label: '包装尺寸(高)', aliasName: '包装尺寸高', value: 'packageH'},
              {label: '单品毛重', value: 'packageWeight'},
              {label: '箱规(长)', aliasName: '箱规长', value: 'cartonSizeL'},
              {label: '箱规(宽)', aliasName: '箱规宽', value: 'cartonSizeW'},
              {label: '箱规(高)', aliasName: '箱规高', value: 'cartonSizeH'},
              {label: '单箱净重', value: 'singleNetWeight'},
              {label: '单箱毛重', value: 'singleWeight'},
              {label: '单箱数量', value: 'singleQuantity'},
            ]
          },
          {
            label: '物流信息',
            fields: [
              {label: '关税申报单价币种', aliasName: '关税申报币种', value: 'dutyCurrency'},
              {label: '关税申报单价金额', aliasName: '关税申报单价', value: 'dutyPrice'},
              {label: '中文报关名', value: 'chineseCustomsName'},
              {label: '英文报关名', value: 'englishCustomsName'},
            ]
          },
          {
            label: '海关编码',
            fields: [
              {label: '中国', aliasName: '中国海关编码', value: 'cnCustomsCode'},
              {label: '美国', aliasName: '美国海关编码', value: 'usCustomsCode'},
              {label: '加拿大', aliasName: '加拿大海关编码', value: 'caCustomsCode'},
              {label: '墨西哥', aliasName: '墨西哥海关编码', value: 'mxCustomsCode'},
              {label: '英国', aliasName: '英国海关编码', value: 'ukCustomsCode'},
              {label: '德国', aliasName: '德国海关编码', value: 'deCustomsCode'},
              {label: '意大利', aliasName: '意大利海关编码', value: 'itCustomsCode'},
              {label: '法国', aliasName: '法国海关编码', value: 'frCustomsCode'},
              {label: '荷兰', aliasName: '荷兰海关编码', value: 'nlCustomsCode'},
              {label: '西班牙', aliasName: '西班牙海关编码', value: 'esCustomsCode'},
              {label: '澳洲', aliasName: '澳洲海关编码', value: 'auCustomsCode'},
              {label: '新加坡', aliasName: '新加坡海关编码', value: 'sgCustomsCode'},
              {label: '日本', aliasName: '日本海关编码', value: 'jpCustomsCode'},
              {label: '印度', aliasName: '印度海关编码', value: 'inCustomsCode'},
              {label: '阿联酋', aliasName: '阿联酋海关编码', value: 'aeCustomsCode'},
              {label: '沙特阿拉伯', aliasName: '沙特阿拉伯海关编码', value: 'saCustomsCode'},
            ]
          },
        ]
      }
    },
    computed: {
      updateFields() {
        return [...this.tplFields[0], ...this.tplFields[1], ...this.tplFields[2], ...this.tplFields[3]];
      },
      updateFieldParams() {
        return {
          fields: this.updateFields.map(item => ({
            displayName: item.aliasName || item.label,
            fieldName: item.value,
          }))
        }
      }
    },
    methods: {
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importUpdateProduct({
          attachmentId: attId,
          ...this.updateFieldParams,
        })
          .then((res) => {
            this.$gjImportHandle(res, uploadCb);
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
      },
      confirm() {
        if (this.updateFields.length < 2) {
          this.$gjMessage.success('请先勾选要更新的字段');
        }
      }
    }
  }
</script>

<style scoped>
  .checkbox {
    margin: 4px 0;
  }
  .upload-btn {
    margin: 10px 0;
  }
  .checkbox-group {
    background: #F7F9fE;
    padding: 10px;
    margin-bottom: 12px;
  }
  /deep/ .all-checkbox .el-checkbox__label {
    margin-bottom: 4px;
    font-weight: bold;
  }
</style>
